import { render } from "./GoverningBodyView.vue?vue&type=template&id=306d5737"
import script from "./GoverningBodyView.vue?vue&type=script&lang=js"
export * from "./GoverningBodyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__